module.exports = __webpack_public_path__ + "static/gallery-2-5e4e01baaaaa29a0ea155bb1fc21d2ef.jpg";